import { getChainConfigEntry } from '@/config/chain'
import { Token } from '@/domain/types/Token'
import { UseOngoingCampaignsQueryResult } from '@/features/spark-rewards/data/useOngoingCampaignsQuery'
import { assets } from '@/ui/assets'
import { SparkRewardCampaign } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'

export interface FilterRelatedCampaignsParams {
  ongoingCampaignsResult: UseOngoingCampaignsQueryResult
  token: Token
  chainId: number
}

export function filterRelatedCampaigns({
  ongoingCampaignsResult,
  token,
  chainId,
}: FilterRelatedCampaignsParams): SparkRewardCampaign[] {
  const { tokenDefinitionRepository } = getChainConfigEntry(chainId)

  return (ongoingCampaignsResult.data ?? [])
    .filter((campaign) => campaign.type === 'sparklend')
    .filter((campaign) => campaign.chainId === chainId)
    .filter((campaign) => campaign.borrowTokenSymbols.includes(token.symbol))
    .map((campaign) => ({
      campaignId: campaign.id,
      rewardTokenSymbol: campaign.rewardTokenSymbol,
      rewardTokenLogo: tokenDefinitionRepository.findBySymbol(campaign.rewardTokenSymbol)?.logo ?? assets.token.unknown,
      longDescription: campaign.longDescription,
      apy: campaign.apy,
    }))
}
